import { render, staticRenderFns } from "./kuran-goods-fullwidth.vue?vue&type=template&id=38b707bf&scoped=true"
import script from "./kuran-goods-fullwidth.vue?vue&type=script&lang=js"
export * from "./kuran-goods-fullwidth.vue?vue&type=script&lang=js"
import style0 from "./kuran-goods-fullwidth.vue?vue&type=style&index=0&id=38b707bf&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b707bf",
  null
  
)

export default component.exports